<script setup lang="ts">
import type { RouteLocationRaw } from "vue-router";
import type { SiteResource } from "@carnet/api/backoffice";

// `to` : destination du lien vers le détail du site, fournie par l'app hôte
// (web : `$localePath({ name: "sites.detail" })`) — absente, pas de lien.
defineProps<{
  site: SiteResource;
  to?: RouteLocationRaw;
  opensOnMap?: boolean;
}>();

const emit = defineEmits<{
  select: [];
}>();

const { t } = useI18n();
</script>

<template>
  <article class="@container/tile group/tile relative flex items-start flex-row in-[.group\/popup]:flex-col justify-between gap-4">
    <div class="flex flex-col gap-4 min-w-0 in-[.group\/sheet]:flex-1">
      <div class="min-w-0">
        <h3 class="text-xl @xs/tile:text-2xl font-semibold wrap-break-words">
          {{ site.name }}
        </h3>
        <p v-if="site.nearbyCityLabel" class="mt-1">{{ site.nearbyCityLabel }}</p>
        <UBadge v-if="['waiting_for_validation', 'in_review'].includes(site.validationStatus)" variant="soft" color="error" size="sm" class="mt-2.5">{{
          $t(`site.validationStatus.${site.validationStatus}`)
        }}</UBadge>
      </div>

      <div v-if="site.environment || site.depthCategory" class="flex flex-wrap gap-1 mt-1">
        <span class="text-base text-blue-600">{{ [site.environment.label, site.depthCategory.label].filter((e) => e).join(" – ") }}</span>
      </div>

      <p v-if="site.participationCount" class="text-sm">{{ t("site.tile.participationCount", site.participationCount) }}</p>

      <slot />
    </div>

    <AppTileLink v-if="to" :to :aria-label="t('site.tile.link', { name: site.name })" icon="icon:arrowRight" />
    <AppTileButton
      v-else-if="opensOnMap"
      :aria-label="t('site.tile.showOnMap', { name: site.name })"
      icon="icon:marker"
      @click="() => emit('select')"
    />
  </article>
</template>
